/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer(
    $input: CreateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    createCustomer(input: $input, condition: $condition) {
      createdAt
      updatedAt
      id
      name
      netsuiteID
      services {
        id
        name
        children {
          id
          name
          children {
            id
            name
            children {
              id
              name
            }
          }
        }
      }
      ssoDomain
      selfValidation
      defaultRoles
      customerOf
      appClientID
      appClientScopes
      tradeinteropMemberId
      isTemplate
      createdFromTemplate
      errorNotificationAddress
      partner
      documentRetentionDays
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      createdAt
      updatedAt
      id
      name
      netsuiteID
      services {
        id
        name
        children {
          id
          name
          children {
            id
            name
            children {
              id
              name
            }
          }
        }
      }
      ssoDomain
      selfValidation
      defaultRoles
      customerOf
      appClientID
      appClientScopes
      tradeinteropMemberId
      isTemplate
      createdFromTemplate
      errorNotificationAddress
      partner
      documentRetentionDays
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer(
    $input: DeleteCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    deleteCustomer(input: $input, condition: $condition) {
      createdAt
      updatedAt
      id
      name
      netsuiteID
      services {
        id
        name
        children {
          id
          name
          children {
            id
            name
            children {
              id
              name
            }
          }
        }
      }
      ssoDomain
      selfValidation
      defaultRoles
      customerOf
      appClientID
      appClientScopes
      tradeinteropMemberId
      isTemplate
      createdFromTemplate
      errorNotificationAddress
      partner
      documentRetentionDays
    }
  }
`;
export const createCompanyData = /* GraphQL */ `
  mutation CreateCompanyData(
    $input: CreateCompanyDataInput!
    $condition: ModelCompanyDataConditionInput
  ) {
    createCompanyData(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      name
      companyCode
      businessUnit
      gln
      coc
      vatID
      address
      city
      postalCode
      opCo
      emailAddress
      businessArea
      synonyms {
        operator
        value
      }
      exportType
      addressLine2
      country
      IBAN
      BIC
      termsAndConditions
      isoCode
      active
      default
    }
  }
`;
export const updateCompanyData = /* GraphQL */ `
  mutation UpdateCompanyData(
    $input: UpdateCompanyDataInput!
    $condition: ModelCompanyDataConditionInput
  ) {
    updateCompanyData(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      name
      companyCode
      businessUnit
      gln
      coc
      vatID
      address
      city
      postalCode
      opCo
      emailAddress
      businessArea
      synonyms {
        operator
        value
      }
      exportType
      addressLine2
      country
      IBAN
      BIC
      termsAndConditions
      isoCode
      active
      default
    }
  }
`;
export const deleteCompanyData = /* GraphQL */ `
  mutation DeleteCompanyData(
    $input: DeleteCompanyDataInput!
    $condition: ModelCompanyDataConditionInput
  ) {
    deleteCompanyData(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      name
      companyCode
      businessUnit
      gln
      coc
      vatID
      address
      city
      postalCode
      opCo
      emailAddress
      businessArea
      synonyms {
        operator
        value
      }
      exportType
      addressLine2
      country
      IBAN
      BIC
      termsAndConditions
      isoCode
      active
      default
    }
  }
`;
export const createDomainSetting = /* GraphQL */ `
  mutation CreateDomainSetting(
    $input: CreateDomainSettingInput!
    $condition: ModelDomainSettingConditionInput
  ) {
    createDomainSetting(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      denied
      domain
      ignoredFiles
      fileTypeProcess {
        process
        friendlyProcessName
        filePattern
      }
      excluded {
        type
        search
      }
    }
  }
`;
export const updateDomainSetting = /* GraphQL */ `
  mutation UpdateDomainSetting(
    $input: UpdateDomainSettingInput!
    $condition: ModelDomainSettingConditionInput
  ) {
    updateDomainSetting(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      denied
      domain
      ignoredFiles
      fileTypeProcess {
        process
        friendlyProcessName
        filePattern
      }
      excluded {
        type
        search
      }
    }
  }
`;
export const deleteDomainSetting = /* GraphQL */ `
  mutation DeleteDomainSetting(
    $input: DeleteDomainSettingInput!
    $condition: ModelDomainSettingConditionInput
  ) {
    deleteDomainSetting(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      denied
      domain
      ignoredFiles
      fileTypeProcess {
        process
        friendlyProcessName
        filePattern
      }
      excluded {
        type
        search
      }
    }
  }
`;
export const createDocument = /* GraphQL */ `
  mutation CreateDocument(
    $input: CreateDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    createDocument(input: $input, condition: $condition) {
      id
      icGuid
      createdAt
      createdEpoch
      updatedAt
      amountGross
      amountNet1
      amountNet2
      amountNet3
      amountNetTotal
      amountVat1
      amountVat2
      amountVat3
      amountVatTotal
      appliedMapping
      bankName
      btBUMID
      btInvoiceRef
      btOrigin
      btReceiverRef
      btScanDate
      businessArea
      businessUnit
      companyID
      companyCode
      companyName
      companyNameOverride
      currency
      customerID
      deliveryDate
      deliveryTerms
      deliveryEndDate
      deliveryLocation
      deliveryInstruction
      documentNumber
      documentSubType
      documentType
      dueDate
      expiresAt
      exportApproved
      exportMapping
      exportType
      externalSystem
      externalSystemID
      forceValid
      gAccount
      gAmount
      invoiceDate
      invoiceNumber
      invoiceType
      integrationDetail
      ivsProcessID
      lastError
      noteNumber
      noteToSupplier
      opCo
      owner
      orderDate
      orderType
      paymentTerms
      pdfUploadedFrontEnd
      purchasingCategory
      poCreator
      poOwner
      purpose
      receivedMessageID
      receiverAddress1
      receiverAddress2
      receiverCity
      receiverCompanyName
      receiverCompanyCode
      receiverContractNumber
      receiverCountryCode
      receiverContactName
      receiverContactFirstName
      receiverContactPhoneNumber
      receiverContactEmailAddress
      receiverGLN
      receiverKVK
      receiverNetServiceId
      receiverOrdernumber
      receiverPostalCode
      receiverVatId
      receiverEmailAddress
      receiverEndPointIsoCode
      receiverEndPointID
      remark
      returnDate
      returnEmailAddress
      returnStatus
      s3ResourceAttachment {
        s3Resource
      }
      s3ResourceMiscellaneous {
        s3Resource
      }
      s3ResourceWebserviceResponse
      s3ResourceExportedDocument
      s3ResourceGeneratedImage
      s3ResourceOrgImage
      s3ResourceOrgXML
      source
      status
      secondaryStatus
      senderCode
      senderAddress1
      senderAddress2
      senderCompanyCode
      senderContractNumber
      senderCountryCode
      senderContactName
      senderContactFirstName
      senderContactPhoneNumber
      senderContactEmailAddress
      senderDescription
      senderDocCode
      senderDocNum
      senderEmailAddress
      senderGLN
      senderIBAN
      senderName
      senderNote
      senderReference
      senderTerms
      senderPostalCode
      senderVatId
      senderKVK
      subscriptionType
      supplierAddress1
      supplierAddress2
      supplierBBAN
      supplierCity
      supplierCountryCode
      supplierDescription
      supplierEmailAddress
      supplierGLN
      supplierIBAN
      supplierKVK
      supplierName
      supplierNetServiceId
      supplierCode
      senderRecognitionInput
      supplierRecognitionInput
      supplierOrdernumber
      supplierPostalCode
      supplierVatId
      swiftCode
      vatRate1
      vatRate2
      vatRate3
      history {
        id
        createdAt
        user
        description
        type
        documentChanges {
          field
          oldValue
          newValue
        }
      }
      lines {
        id
        lineNumber
        lineNetTotal
        lineVatRate
        lineVatAmount
        lineUnitPrice
        lineQuantity
        lineDescription
        lineUoM
        lineArticleCode
        lineSupplierArticleCode
        lineOrderNumber
        lineDiscountRate
        lineDiscountAmount
        lineDiscountName
        lineFreeNumber1
        lineFreeNumber2
        lineFreeNumber3
        lineFreeText1
        lineFreeText2
        lineFreeText3
      }
      locked
      lockedBy
      lockedSince
      hasBeenReProcessed
      sendScanReportToBasware
      scanReportCode
      scanReportDescription
      scanReportComment
      title
      linkedDocuments {
        documentID
        documentType
      }
    }
  }
`;
export const updateDocument = /* GraphQL */ `
  mutation UpdateDocument(
    $input: UpdateDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    updateDocument(input: $input, condition: $condition) {
      id
      icGuid
      createdAt
      createdEpoch
      updatedAt
      amountGross
      amountNet1
      amountNet2
      amountNet3
      amountNetTotal
      amountVat1
      amountVat2
      amountVat3
      amountVatTotal
      appliedMapping
      bankName
      btBUMID
      btInvoiceRef
      btOrigin
      btReceiverRef
      btScanDate
      businessArea
      businessUnit
      companyID
      companyCode
      companyName
      companyNameOverride
      currency
      customerID
      deliveryDate
      deliveryTerms
      deliveryEndDate
      deliveryLocation
      deliveryInstruction
      documentNumber
      documentSubType
      documentType
      dueDate
      expiresAt
      exportApproved
      exportMapping
      exportType
      externalSystem
      externalSystemID
      forceValid
      gAccount
      gAmount
      invoiceDate
      invoiceNumber
      invoiceType
      integrationDetail
      ivsProcessID
      lastError
      noteNumber
      noteToSupplier
      opCo
      owner
      orderDate
      orderType
      paymentTerms
      pdfUploadedFrontEnd
      purchasingCategory
      poCreator
      poOwner
      purpose
      receivedMessageID
      receiverAddress1
      receiverAddress2
      receiverCity
      receiverCompanyName
      receiverCompanyCode
      receiverContractNumber
      receiverCountryCode
      receiverContactName
      receiverContactFirstName
      receiverContactPhoneNumber
      receiverContactEmailAddress
      receiverGLN
      receiverKVK
      receiverNetServiceId
      receiverOrdernumber
      receiverPostalCode
      receiverVatId
      receiverEmailAddress
      receiverEndPointIsoCode
      receiverEndPointID
      remark
      returnDate
      returnEmailAddress
      returnStatus
      s3ResourceAttachment {
        s3Resource
      }
      s3ResourceMiscellaneous {
        s3Resource
      }
      s3ResourceWebserviceResponse
      s3ResourceExportedDocument
      s3ResourceGeneratedImage
      s3ResourceOrgImage
      s3ResourceOrgXML
      source
      status
      secondaryStatus
      senderCode
      senderAddress1
      senderAddress2
      senderCompanyCode
      senderContractNumber
      senderCountryCode
      senderContactName
      senderContactFirstName
      senderContactPhoneNumber
      senderContactEmailAddress
      senderDescription
      senderDocCode
      senderDocNum
      senderEmailAddress
      senderGLN
      senderIBAN
      senderName
      senderNote
      senderReference
      senderTerms
      senderPostalCode
      senderVatId
      senderKVK
      subscriptionType
      supplierAddress1
      supplierAddress2
      supplierBBAN
      supplierCity
      supplierCountryCode
      supplierDescription
      supplierEmailAddress
      supplierGLN
      supplierIBAN
      supplierKVK
      supplierName
      supplierNetServiceId
      supplierCode
      senderRecognitionInput
      supplierRecognitionInput
      supplierOrdernumber
      supplierPostalCode
      supplierVatId
      swiftCode
      vatRate1
      vatRate2
      vatRate3
      history {
        id
        createdAt
        user
        description
        type
        documentChanges {
          field
          oldValue
          newValue
        }
      }
      lines {
        id
        lineNumber
        lineNetTotal
        lineVatRate
        lineVatAmount
        lineUnitPrice
        lineQuantity
        lineDescription
        lineUoM
        lineArticleCode
        lineSupplierArticleCode
        lineOrderNumber
        lineDiscountRate
        lineDiscountAmount
        lineDiscountName
        lineFreeNumber1
        lineFreeNumber2
        lineFreeNumber3
        lineFreeText1
        lineFreeText2
        lineFreeText3
      }
      locked
      lockedBy
      lockedSince
      hasBeenReProcessed
      sendScanReportToBasware
      scanReportCode
      scanReportDescription
      scanReportComment
      title
      linkedDocuments {
        documentID
        documentType
      }
    }
  }
`;
export const deleteDocument = /* GraphQL */ `
  mutation DeleteDocument(
    $input: DeleteDocumentInput!
    $condition: ModelDocumentConditionInput
  ) {
    deleteDocument(input: $input, condition: $condition) {
      id
      icGuid
      createdAt
      createdEpoch
      updatedAt
      amountGross
      amountNet1
      amountNet2
      amountNet3
      amountNetTotal
      amountVat1
      amountVat2
      amountVat3
      amountVatTotal
      appliedMapping
      bankName
      btBUMID
      btInvoiceRef
      btOrigin
      btReceiverRef
      btScanDate
      businessArea
      businessUnit
      companyID
      companyCode
      companyName
      companyNameOverride
      currency
      customerID
      deliveryDate
      deliveryTerms
      deliveryEndDate
      deliveryLocation
      deliveryInstruction
      documentNumber
      documentSubType
      documentType
      dueDate
      expiresAt
      exportApproved
      exportMapping
      exportType
      externalSystem
      externalSystemID
      forceValid
      gAccount
      gAmount
      invoiceDate
      invoiceNumber
      invoiceType
      integrationDetail
      ivsProcessID
      lastError
      noteNumber
      noteToSupplier
      opCo
      owner
      orderDate
      orderType
      paymentTerms
      pdfUploadedFrontEnd
      purchasingCategory
      poCreator
      poOwner
      purpose
      receivedMessageID
      receiverAddress1
      receiverAddress2
      receiverCity
      receiverCompanyName
      receiverCompanyCode
      receiverContractNumber
      receiverCountryCode
      receiverContactName
      receiverContactFirstName
      receiverContactPhoneNumber
      receiverContactEmailAddress
      receiverGLN
      receiverKVK
      receiverNetServiceId
      receiverOrdernumber
      receiverPostalCode
      receiverVatId
      receiverEmailAddress
      receiverEndPointIsoCode
      receiverEndPointID
      remark
      returnDate
      returnEmailAddress
      returnStatus
      s3ResourceAttachment {
        s3Resource
      }
      s3ResourceMiscellaneous {
        s3Resource
      }
      s3ResourceWebserviceResponse
      s3ResourceExportedDocument
      s3ResourceGeneratedImage
      s3ResourceOrgImage
      s3ResourceOrgXML
      source
      status
      secondaryStatus
      senderCode
      senderAddress1
      senderAddress2
      senderCompanyCode
      senderContractNumber
      senderCountryCode
      senderContactName
      senderContactFirstName
      senderContactPhoneNumber
      senderContactEmailAddress
      senderDescription
      senderDocCode
      senderDocNum
      senderEmailAddress
      senderGLN
      senderIBAN
      senderName
      senderNote
      senderReference
      senderTerms
      senderPostalCode
      senderVatId
      senderKVK
      subscriptionType
      supplierAddress1
      supplierAddress2
      supplierBBAN
      supplierCity
      supplierCountryCode
      supplierDescription
      supplierEmailAddress
      supplierGLN
      supplierIBAN
      supplierKVK
      supplierName
      supplierNetServiceId
      supplierCode
      senderRecognitionInput
      supplierRecognitionInput
      supplierOrdernumber
      supplierPostalCode
      supplierVatId
      swiftCode
      vatRate1
      vatRate2
      vatRate3
      history {
        id
        createdAt
        user
        description
        type
        documentChanges {
          field
          oldValue
          newValue
        }
      }
      lines {
        id
        lineNumber
        lineNetTotal
        lineVatRate
        lineVatAmount
        lineUnitPrice
        lineQuantity
        lineDescription
        lineUoM
        lineArticleCode
        lineSupplierArticleCode
        lineOrderNumber
        lineDiscountRate
        lineDiscountAmount
        lineDiscountName
        lineFreeNumber1
        lineFreeNumber2
        lineFreeNumber3
        lineFreeText1
        lineFreeText2
        lineFreeText3
      }
      locked
      lockedBy
      lockedSince
      hasBeenReProcessed
      sendScanReportToBasware
      scanReportCode
      scanReportDescription
      scanReportComment
      title
      linkedDocuments {
        documentID
        documentType
      }
    }
  }
`;
export const createCrudHistory = /* GraphQL */ `
  mutation CreateCrudHistory(
    $input: CreateCrudHistoryInput!
    $condition: ModelCrudHistoryConditionInput
  ) {
    createCrudHistory(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      change
      section
      tableLineID
      name
      user
      changes {
        field
        oldValue
        newValue
      }
      expiresAt
    }
  }
`;
export const updateCrudHistory = /* GraphQL */ `
  mutation UpdateCrudHistory(
    $input: UpdateCrudHistoryInput!
    $condition: ModelCrudHistoryConditionInput
  ) {
    updateCrudHistory(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      change
      section
      tableLineID
      name
      user
      changes {
        field
        oldValue
        newValue
      }
      expiresAt
    }
  }
`;
export const deleteCrudHistory = /* GraphQL */ `
  mutation DeleteCrudHistory(
    $input: DeleteCrudHistoryInput!
    $condition: ModelCrudHistoryConditionInput
  ) {
    deleteCrudHistory(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      change
      section
      tableLineID
      name
      user
      changes {
        field
        oldValue
        newValue
      }
      expiresAt
    }
  }
`;
export const createReturnServiceEmailTemplates = /* GraphQL */ `
  mutation CreateReturnServiceEmailTemplates(
    $input: CreateReturnServiceEmailTemplatesInput!
    $condition: ModelReturnServiceEmailTemplatesConditionInput
  ) {
    createReturnServiceEmailTemplates(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      templateName
      senderAddress
      replyToAddress
      to
      cc
      bcc
      subject
      htmlBody
      automatic
    }
  }
`;
export const updateReturnServiceEmailTemplates = /* GraphQL */ `
  mutation UpdateReturnServiceEmailTemplates(
    $input: UpdateReturnServiceEmailTemplatesInput!
    $condition: ModelReturnServiceEmailTemplatesConditionInput
  ) {
    updateReturnServiceEmailTemplates(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      templateName
      senderAddress
      replyToAddress
      to
      cc
      bcc
      subject
      htmlBody
      automatic
    }
  }
`;
export const deleteReturnServiceEmailTemplates = /* GraphQL */ `
  mutation DeleteReturnServiceEmailTemplates(
    $input: DeleteReturnServiceEmailTemplatesInput!
    $condition: ModelReturnServiceEmailTemplatesConditionInput
  ) {
    deleteReturnServiceEmailTemplates(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      templateName
      senderAddress
      replyToAddress
      to
      cc
      bcc
      subject
      htmlBody
      automatic
    }
  }
`;
export const createGLNSupplier = /* GraphQL */ `
  mutation CreateGLNSupplier(
    $input: CreateGLNSupplierInput!
    $condition: ModelGLNSupplierConditionInput
  ) {
    createGLNSupplier(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      opCo
      companyCode
      supplierCode
      supplierName
      glnNumbers
    }
  }
`;
export const updateGLNSupplier = /* GraphQL */ `
  mutation UpdateGLNSupplier(
    $input: UpdateGLNSupplierInput!
    $condition: ModelGLNSupplierConditionInput
  ) {
    updateGLNSupplier(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      opCo
      companyCode
      supplierCode
      supplierName
      glnNumbers
    }
  }
`;
export const deleteGLNSupplier = /* GraphQL */ `
  mutation DeleteGLNSupplier(
    $input: DeleteGLNSupplierInput!
    $condition: ModelGLNSupplierConditionInput
  ) {
    deleteGLNSupplier(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      opCo
      companyCode
      supplierCode
      supplierName
      glnNumbers
    }
  }
`;
export const createReceivedMessages = /* GraphQL */ `
  mutation CreateReceivedMessages(
    $input: CreateReceivedMessagesInput!
    $condition: ModelReceivedMessagesConditionInput
  ) {
    createReceivedMessages(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      attribute1
      attribute2
      attribute3
      attribute4
      attribute5
      bodyS3Resource
      domain
      errorText
      expiresAt
      hasIgnoredFiles
      ignoreds3ResourceAttachment {
        s3Resource
      }
      s3ResourceAttachment {
        s3Resource
      }
      secondaryStatus
      senderAddress
      status
      subject
      companyCode
      integrationID
      recipientAddress
      forceValid
      processID
      processName
      history {
        id
        createdAt
        user
        description
        type
        documentChanges {
          field
          oldValue
          newValue
        }
      }
      test
    }
  }
`;
export const updateReceivedMessages = /* GraphQL */ `
  mutation UpdateReceivedMessages(
    $input: UpdateReceivedMessagesInput!
    $condition: ModelReceivedMessagesConditionInput
  ) {
    updateReceivedMessages(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      attribute1
      attribute2
      attribute3
      attribute4
      attribute5
      bodyS3Resource
      domain
      errorText
      expiresAt
      hasIgnoredFiles
      ignoreds3ResourceAttachment {
        s3Resource
      }
      s3ResourceAttachment {
        s3Resource
      }
      secondaryStatus
      senderAddress
      status
      subject
      companyCode
      integrationID
      recipientAddress
      forceValid
      processID
      processName
      history {
        id
        createdAt
        user
        description
        type
        documentChanges {
          field
          oldValue
          newValue
        }
      }
      test
    }
  }
`;
export const deleteReceivedMessages = /* GraphQL */ `
  mutation DeleteReceivedMessages(
    $input: DeleteReceivedMessagesInput!
    $condition: ModelReceivedMessagesConditionInput
  ) {
    deleteReceivedMessages(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      customerID
      attribute1
      attribute2
      attribute3
      attribute4
      attribute5
      bodyS3Resource
      domain
      errorText
      expiresAt
      hasIgnoredFiles
      ignoreds3ResourceAttachment {
        s3Resource
      }
      s3ResourceAttachment {
        s3Resource
      }
      secondaryStatus
      senderAddress
      status
      subject
      companyCode
      integrationID
      recipientAddress
      forceValid
      processID
      processName
      history {
        id
        createdAt
        user
        description
        type
        documentChanges {
          field
          oldValue
          newValue
        }
      }
      test
    }
  }
`;
export const createFieldActions = /* GraphQL */ `
  mutation CreateFieldActions(
    $input: CreateFieldActionsInput!
    $condition: ModelFieldActionsConditionInput
  ) {
    createFieldActions(input: $input, condition: $condition) {
      id
      filter
      type
      createdAt
      updatedAt
      customerID
      fieldName
      fieldLocation
      input
      value
      raiseOnError
      errorText
      stepIndex
      beforeProcess
      afterProcess
      method
      documentType
      documentSubType
      description
      integrationID
      requestUrl
      requestHeaders
    }
  }
`;
export const updateFieldActions = /* GraphQL */ `
  mutation UpdateFieldActions(
    $input: UpdateFieldActionsInput!
    $condition: ModelFieldActionsConditionInput
  ) {
    updateFieldActions(input: $input, condition: $condition) {
      id
      filter
      type
      createdAt
      updatedAt
      customerID
      fieldName
      fieldLocation
      input
      value
      raiseOnError
      errorText
      stepIndex
      beforeProcess
      afterProcess
      method
      documentType
      documentSubType
      description
      integrationID
      requestUrl
      requestHeaders
    }
  }
`;
export const deleteFieldActions = /* GraphQL */ `
  mutation DeleteFieldActions(
    $input: DeleteFieldActionsInput!
    $condition: ModelFieldActionsConditionInput
  ) {
    deleteFieldActions(input: $input, condition: $condition) {
      id
      filter
      type
      createdAt
      updatedAt
      customerID
      fieldName
      fieldLocation
      input
      value
      raiseOnError
      errorText
      stepIndex
      beforeProcess
      afterProcess
      method
      documentType
      documentSubType
      description
      integrationID
      requestUrl
      requestHeaders
    }
  }
`;
export const createCompanyRecognitionOutcome = /* GraphQL */ `
  mutation CreateCompanyRecognitionOutcome(
    $input: CreateCompanyRecognitionOutcomeInput!
    $condition: ModelCompanyRecognitionOutcomeConditionInput
  ) {
    createCompanyRecognitionOutcome(input: $input, condition: $condition) {
      id
      customerID
      documentID
      success
      matchedCompanies {
        companyID
        synonym
        token
        ratio
        lengthRatio
      }
      recognizedCompanyID
      recognizedSynonym
      recognizedToken
      recognizedCertaintyScore
      textractUsed
      quickRatio
      tokensFromInvoice
      createdAt
      updatedAt
    }
  }
`;
export const updateCompanyRecognitionOutcome = /* GraphQL */ `
  mutation UpdateCompanyRecognitionOutcome(
    $input: UpdateCompanyRecognitionOutcomeInput!
    $condition: ModelCompanyRecognitionOutcomeConditionInput
  ) {
    updateCompanyRecognitionOutcome(input: $input, condition: $condition) {
      id
      customerID
      documentID
      success
      matchedCompanies {
        companyID
        synonym
        token
        ratio
        lengthRatio
      }
      recognizedCompanyID
      recognizedSynonym
      recognizedToken
      recognizedCertaintyScore
      textractUsed
      quickRatio
      tokensFromInvoice
      createdAt
      updatedAt
    }
  }
`;
export const deleteCompanyRecognitionOutcome = /* GraphQL */ `
  mutation DeleteCompanyRecognitionOutcome(
    $input: DeleteCompanyRecognitionOutcomeInput!
    $condition: ModelCompanyRecognitionOutcomeConditionInput
  ) {
    deleteCompanyRecognitionOutcome(input: $input, condition: $condition) {
      id
      customerID
      documentID
      success
      matchedCompanies {
        companyID
        synonym
        token
        ratio
        lengthRatio
      }
      recognizedCompanyID
      recognizedSynonym
      recognizedToken
      recognizedCertaintyScore
      textractUsed
      quickRatio
      tokensFromInvoice
      createdAt
      updatedAt
    }
  }
`;
export const createFieldConfiguration = /* GraphQL */ `
  mutation CreateFieldConfiguration(
    $input: CreateFieldConfigurationInput!
    $condition: ModelFieldConfigurationConditionInput
  ) {
    createFieldConfiguration(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      documentTypeConcat
      documentType
      documentSubType
      fields {
        field
        editable
        length
      }
    }
  }
`;
export const updateFieldConfiguration = /* GraphQL */ `
  mutation UpdateFieldConfiguration(
    $input: UpdateFieldConfigurationInput!
    $condition: ModelFieldConfigurationConditionInput
  ) {
    updateFieldConfiguration(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      documentTypeConcat
      documentType
      documentSubType
      fields {
        field
        editable
        length
      }
    }
  }
`;
export const deleteFieldConfiguration = /* GraphQL */ `
  mutation DeleteFieldConfiguration(
    $input: DeleteFieldConfigurationInput!
    $condition: ModelFieldConfigurationConditionInput
  ) {
    deleteFieldConfiguration(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      documentTypeConcat
      documentType
      documentSubType
      fields {
        field
        editable
        length
      }
    }
  }
`;
export const createXMLTypeConfiguration = /* GraphQL */ `
  mutation CreateXMLTypeConfiguration(
    $input: CreateXMLTypeConfigurationInput!
    $condition: ModelXMLTypeConfigurationConditionInput
  ) {
    createXMLTypeConfiguration(input: $input, condition: $condition) {
      createdAt
      updatedAt
      id
      xmlType
      customerID
      xPath
      imageXpath
      attachmentXpath
      nameSpace
      xsltFileName
      documentType
      documentSubType
    }
  }
`;
export const updateXMLTypeConfiguration = /* GraphQL */ `
  mutation UpdateXMLTypeConfiguration(
    $input: UpdateXMLTypeConfigurationInput!
    $condition: ModelXMLTypeConfigurationConditionInput
  ) {
    updateXMLTypeConfiguration(input: $input, condition: $condition) {
      createdAt
      updatedAt
      id
      xmlType
      customerID
      xPath
      imageXpath
      attachmentXpath
      nameSpace
      xsltFileName
      documentType
      documentSubType
    }
  }
`;
export const deleteXMLTypeConfiguration = /* GraphQL */ `
  mutation DeleteXMLTypeConfiguration(
    $input: DeleteXMLTypeConfigurationInput!
    $condition: ModelXMLTypeConfigurationConditionInput
  ) {
    deleteXMLTypeConfiguration(input: $input, condition: $condition) {
      createdAt
      updatedAt
      id
      xmlType
      customerID
      xPath
      imageXpath
      attachmentXpath
      nameSpace
      xsltFileName
      documentType
      documentSubType
    }
  }
`;
export const createRMProcessSelection = /* GraphQL */ `
  mutation CreateRMProcessSelection(
    $input: CreateRMProcessSelectionInput!
    $condition: ModelRMProcessSelectionConditionInput
  ) {
    createRMProcessSelection(input: $input, condition: $condition) {
      createdAt
      updatedAt
      id
      customerID
      processID
      name
      processSelection
      allowedExtension
    }
  }
`;
export const updateRMProcessSelection = /* GraphQL */ `
  mutation UpdateRMProcessSelection(
    $input: UpdateRMProcessSelectionInput!
    $condition: ModelRMProcessSelectionConditionInput
  ) {
    updateRMProcessSelection(input: $input, condition: $condition) {
      createdAt
      updatedAt
      id
      customerID
      processID
      name
      processSelection
      allowedExtension
    }
  }
`;
export const deleteRMProcessSelection = /* GraphQL */ `
  mutation DeleteRMProcessSelection(
    $input: DeleteRMProcessSelectionInput!
    $condition: ModelRMProcessSelectionConditionInput
  ) {
    deleteRMProcessSelection(input: $input, condition: $condition) {
      createdAt
      updatedAt
      id
      customerID
      processID
      name
      processSelection
      allowedExtension
    }
  }
`;
export const createPeppolIdentifiers = /* GraphQL */ `
  mutation CreatePeppolIdentifiers(
    $input: CreatePeppolIdentifiersInput!
    $condition: ModelPeppolIdentifiersConditionInput
  ) {
    createPeppolIdentifiers(input: $input, condition: $condition) {
      endpoint
      customerID
      companyCode
      name
      countryCode
      documentIds
      createdAt
      updatedAt
    }
  }
`;
export const updatePeppolIdentifiers = /* GraphQL */ `
  mutation UpdatePeppolIdentifiers(
    $input: UpdatePeppolIdentifiersInput!
    $condition: ModelPeppolIdentifiersConditionInput
  ) {
    updatePeppolIdentifiers(input: $input, condition: $condition) {
      endpoint
      customerID
      companyCode
      name
      countryCode
      documentIds
      createdAt
      updatedAt
    }
  }
`;
export const deletePeppolIdentifiers = /* GraphQL */ `
  mutation DeletePeppolIdentifiers(
    $input: DeletePeppolIdentifiersInput!
    $condition: ModelPeppolIdentifiersConditionInput
  ) {
    deletePeppolIdentifiers(input: $input, condition: $condition) {
      endpoint
      customerID
      companyCode
      name
      countryCode
      documentIds
      createdAt
      updatedAt
    }
  }
`;
export const createDocumentIdentifiers = /* GraphQL */ `
  mutation CreateDocumentIdentifiers(
    $input: CreateDocumentIdentifiersInput!
    $condition: ModelDocumentIdentifiersConditionInput
  ) {
    createDocumentIdentifiers(input: $input, condition: $condition) {
      id
      commonName
      documentIdentifier
      documentType
      identifierExpression
      mappingApplicable
      mapping
      originalXmlMapping
      priority
      type
      vesId
      createdAt
      updatedAt
    }
  }
`;
export const updateDocumentIdentifiers = /* GraphQL */ `
  mutation UpdateDocumentIdentifiers(
    $input: UpdateDocumentIdentifiersInput!
    $condition: ModelDocumentIdentifiersConditionInput
  ) {
    updateDocumentIdentifiers(input: $input, condition: $condition) {
      id
      commonName
      documentIdentifier
      documentType
      identifierExpression
      mappingApplicable
      mapping
      originalXmlMapping
      priority
      type
      vesId
      createdAt
      updatedAt
    }
  }
`;
export const deleteDocumentIdentifiers = /* GraphQL */ `
  mutation DeleteDocumentIdentifiers(
    $input: DeleteDocumentIdentifiersInput!
    $condition: ModelDocumentIdentifiersConditionInput
  ) {
    deleteDocumentIdentifiers(input: $input, condition: $condition) {
      id
      commonName
      documentIdentifier
      documentType
      identifierExpression
      mappingApplicable
      mapping
      originalXmlMapping
      priority
      type
      vesId
      createdAt
      updatedAt
    }
  }
`;
export const createDelayDocument = /* GraphQL */ `
  mutation CreateDelayDocument(
    $input: CreateDelayDocumentInput!
    $condition: ModelDelayDocumentConditionInput
  ) {
    createDelayDocument(input: $input, condition: $condition) {
      icGuid
      customerID
      delayStart
      delayEnd
      createdAt
      updatedAt
    }
  }
`;
export const updateDelayDocument = /* GraphQL */ `
  mutation UpdateDelayDocument(
    $input: UpdateDelayDocumentInput!
    $condition: ModelDelayDocumentConditionInput
  ) {
    updateDelayDocument(input: $input, condition: $condition) {
      icGuid
      customerID
      delayStart
      delayEnd
      createdAt
      updatedAt
    }
  }
`;
export const deleteDelayDocument = /* GraphQL */ `
  mutation DeleteDelayDocument(
    $input: DeleteDelayDocumentInput!
    $condition: ModelDelayDocumentConditionInput
  ) {
    deleteDelayDocument(input: $input, condition: $condition) {
      icGuid
      customerID
      delayStart
      delayEnd
      createdAt
      updatedAt
    }
  }
`;
export const createCustomerMailbox = /* GraphQL */ `
  mutation CreateCustomerMailbox(
    $input: CreateCustomerMailboxInput!
    $condition: ModelCustomerMailboxConditionInput
  ) {
    createCustomerMailbox(input: $input, condition: $condition) {
      mailbox
      customerID
      companyCode
      direction
      exportType
      allowedDomains
      createdAt
      updatedAt
    }
  }
`;
export const updateCustomerMailbox = /* GraphQL */ `
  mutation UpdateCustomerMailbox(
    $input: UpdateCustomerMailboxInput!
    $condition: ModelCustomerMailboxConditionInput
  ) {
    updateCustomerMailbox(input: $input, condition: $condition) {
      mailbox
      customerID
      companyCode
      direction
      exportType
      allowedDomains
      createdAt
      updatedAt
    }
  }
`;
export const deleteCustomerMailbox = /* GraphQL */ `
  mutation DeleteCustomerMailbox(
    $input: DeleteCustomerMailboxInput!
    $condition: ModelCustomerMailboxConditionInput
  ) {
    deleteCustomerMailbox(input: $input, condition: $condition) {
      mailbox
      customerID
      companyCode
      direction
      exportType
      allowedDomains
      createdAt
      updatedAt
    }
  }
`;
export const createEasyMigration = /* GraphQL */ `
  mutation CreateEasyMigration(
    $input: CreateEasyMigrationInput!
    $condition: ModelEasyMigrationConditionInput
  ) {
    createEasyMigration(input: $input, condition: $condition) {
      customerID
      migratedAt
      createdAt
      updatedAt
    }
  }
`;
export const updateEasyMigration = /* GraphQL */ `
  mutation UpdateEasyMigration(
    $input: UpdateEasyMigrationInput!
    $condition: ModelEasyMigrationConditionInput
  ) {
    updateEasyMigration(input: $input, condition: $condition) {
      customerID
      migratedAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteEasyMigration = /* GraphQL */ `
  mutation DeleteEasyMigration(
    $input: DeleteEasyMigrationInput!
    $condition: ModelEasyMigrationConditionInput
  ) {
    deleteEasyMigration(input: $input, condition: $condition) {
      customerID
      migratedAt
      createdAt
      updatedAt
    }
  }
`;
export const createPageroClearanceConfig = /* GraphQL */ `
  mutation CreatePageroClearanceConfig(
    $input: CreatePageroClearanceConfigInput!
    $condition: ModelPageroClearanceConfigConditionInput
  ) {
    createPageroClearanceConfig(input: $input, condition: $condition) {
      id
      code
      country
      documentType
      pageroDocumentType
      error
      documentFieldFilter
      createdAt
      updatedAt
    }
  }
`;
export const updatePageroClearanceConfig = /* GraphQL */ `
  mutation UpdatePageroClearanceConfig(
    $input: UpdatePageroClearanceConfigInput!
    $condition: ModelPageroClearanceConfigConditionInput
  ) {
    updatePageroClearanceConfig(input: $input, condition: $condition) {
      id
      code
      country
      documentType
      pageroDocumentType
      error
      documentFieldFilter
      createdAt
      updatedAt
    }
  }
`;
export const deletePageroClearanceConfig = /* GraphQL */ `
  mutation DeletePageroClearanceConfig(
    $input: DeletePageroClearanceConfigInput!
    $condition: ModelPageroClearanceConfigConditionInput
  ) {
    deletePageroClearanceConfig(input: $input, condition: $condition) {
      id
      code
      country
      documentType
      pageroDocumentType
      error
      documentFieldFilter
      createdAt
      updatedAt
    }
  }
`;
export const createPeppolEndpointValidation = /* GraphQL */ `
  mutation CreatePeppolEndpointValidation(
    $input: CreatePeppolEndpointValidationInput!
    $condition: ModelPeppolEndpointValidationConditionInput
  ) {
    createPeppolEndpointValidation(input: $input, condition: $condition) {
      isoCode
      validationType
      validationValue
      createdAt
      updatedAt
    }
  }
`;
export const updatePeppolEndpointValidation = /* GraphQL */ `
  mutation UpdatePeppolEndpointValidation(
    $input: UpdatePeppolEndpointValidationInput!
    $condition: ModelPeppolEndpointValidationConditionInput
  ) {
    updatePeppolEndpointValidation(input: $input, condition: $condition) {
      isoCode
      validationType
      validationValue
      createdAt
      updatedAt
    }
  }
`;
export const deletePeppolEndpointValidation = /* GraphQL */ `
  mutation DeletePeppolEndpointValidation(
    $input: DeletePeppolEndpointValidationInput!
    $condition: ModelPeppolEndpointValidationConditionInput
  ) {
    deletePeppolEndpointValidation(input: $input, condition: $condition) {
      isoCode
      validationType
      validationValue
      createdAt
      updatedAt
    }
  }
`;
export const createWebhookSubscription = /* GraphQL */ `
  mutation CreateWebhookSubscription(
    $input: CreateWebhookSubscriptionInput!
    $condition: ModelWebhookSubscriptionConditionInput
  ) {
    createWebhookSubscription(input: $input, condition: $condition) {
      id
      customerID
      subscription
      endpoint
      createdAt
      updatedAt
    }
  }
`;
export const updateWebhookSubscription = /* GraphQL */ `
  mutation UpdateWebhookSubscription(
    $input: UpdateWebhookSubscriptionInput!
    $condition: ModelWebhookSubscriptionConditionInput
  ) {
    updateWebhookSubscription(input: $input, condition: $condition) {
      id
      customerID
      subscription
      endpoint
      createdAt
      updatedAt
    }
  }
`;
export const deleteWebhookSubscription = /* GraphQL */ `
  mutation DeleteWebhookSubscription(
    $input: DeleteWebhookSubscriptionInput!
    $condition: ModelWebhookSubscriptionConditionInput
  ) {
    deleteWebhookSubscription(input: $input, condition: $condition) {
      id
      customerID
      subscription
      endpoint
      createdAt
      updatedAt
    }
  }
`;
export const createSmlCache = /* GraphQL */ `
  mutation CreateSmlCache(
    $input: CreateSmlCacheInput!
    $condition: ModelSmlCacheConditionInput
  ) {
    createSmlCache(input: $input, condition: $condition) {
      identifier
      smlResult
      cacheDateTime
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const updateSmlCache = /* GraphQL */ `
  mutation UpdateSmlCache(
    $input: UpdateSmlCacheInput!
    $condition: ModelSmlCacheConditionInput
  ) {
    updateSmlCache(input: $input, condition: $condition) {
      identifier
      smlResult
      cacheDateTime
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteSmlCache = /* GraphQL */ `
  mutation DeleteSmlCache(
    $input: DeleteSmlCacheInput!
    $condition: ModelSmlCacheConditionInput
  ) {
    deleteSmlCache(input: $input, condition: $condition) {
      identifier
      smlResult
      cacheDateTime
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const createTraceLog = /* GraphQL */ `
  mutation CreateTraceLog(
    $input: CreateTraceLogInput!
    $condition: ModelTraceLogConditionInput
  ) {
    createTraceLog(input: $input, condition: $condition) {
      documentID
      customerID
      target
      logType
      processID
      processStepID
      logStream
      message
      timestamp
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const updateTraceLog = /* GraphQL */ `
  mutation UpdateTraceLog(
    $input: UpdateTraceLogInput!
    $condition: ModelTraceLogConditionInput
  ) {
    updateTraceLog(input: $input, condition: $condition) {
      documentID
      customerID
      target
      logType
      processID
      processStepID
      logStream
      message
      timestamp
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteTraceLog = /* GraphQL */ `
  mutation DeleteTraceLog(
    $input: DeleteTraceLogInput!
    $condition: ModelTraceLogConditionInput
  ) {
    deleteTraceLog(input: $input, condition: $condition) {
      documentID
      customerID
      target
      logType
      processID
      processStepID
      logStream
      message
      timestamp
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const createPeppolDeployedDocumentTypes = /* GraphQL */ `
  mutation CreatePeppolDeployedDocumentTypes(
    $input: CreatePeppolDeployedDocumentTypesInput!
    $condition: ModelPeppolDeployedDocumentTypesConditionInput
  ) {
    createPeppolDeployedDocumentTypes(input: $input, condition: $condition) {
      id
      commonName
      documentIdentifier
      processIdentifier
      typeVersion
      updatedAt
      deprecationDate
      testOnly
      createdAt
    }
  }
`;
export const updatePeppolDeployedDocumentTypes = /* GraphQL */ `
  mutation UpdatePeppolDeployedDocumentTypes(
    $input: UpdatePeppolDeployedDocumentTypesInput!
    $condition: ModelPeppolDeployedDocumentTypesConditionInput
  ) {
    updatePeppolDeployedDocumentTypes(input: $input, condition: $condition) {
      id
      commonName
      documentIdentifier
      processIdentifier
      typeVersion
      updatedAt
      deprecationDate
      testOnly
      createdAt
    }
  }
`;
export const deletePeppolDeployedDocumentTypes = /* GraphQL */ `
  mutation DeletePeppolDeployedDocumentTypes(
    $input: DeletePeppolDeployedDocumentTypesInput!
    $condition: ModelPeppolDeployedDocumentTypesConditionInput
  ) {
    deletePeppolDeployedDocumentTypes(input: $input, condition: $condition) {
      id
      commonName
      documentIdentifier
      processIdentifier
      typeVersion
      updatedAt
      deprecationDate
      testOnly
      createdAt
    }
  }
`;
export const createIntegrationFailureState = /* GraphQL */ `
  mutation CreateIntegrationFailureState(
    $input: CreateIntegrationFailureStateInput!
    $condition: ModelIntegrationFailureStateConditionInput
  ) {
    createIntegrationFailureState(input: $input, condition: $condition) {
      id
      consecutiveFailures
      lastError
      lastFailureAt
      jiraTicketKey
      jiraTicketUrl
      createdAt
      updatedAt
    }
  }
`;
export const updateIntegrationFailureState = /* GraphQL */ `
  mutation UpdateIntegrationFailureState(
    $input: UpdateIntegrationFailureStateInput!
    $condition: ModelIntegrationFailureStateConditionInput
  ) {
    updateIntegrationFailureState(input: $input, condition: $condition) {
      id
      consecutiveFailures
      lastError
      lastFailureAt
      jiraTicketKey
      jiraTicketUrl
      createdAt
      updatedAt
    }
  }
`;
export const deleteIntegrationFailureState = /* GraphQL */ `
  mutation DeleteIntegrationFailureState(
    $input: DeleteIntegrationFailureStateInput!
    $condition: ModelIntegrationFailureStateConditionInput
  ) {
    deleteIntegrationFailureState(input: $input, condition: $condition) {
      id
      consecutiveFailures
      lastError
      lastFailureAt
      jiraTicketKey
      jiraTicketUrl
      createdAt
      updatedAt
    }
  }
`;
export const createRetryState = /* GraphQL */ `
  mutation CreateRetryState(
    $input: CreateRetryStateInput!
    $condition: ModelRetryStateConditionInput
  ) {
    createRetryState(input: $input, condition: $condition) {
      id
      customerId
      documentId
      queueArn
      retryCount
      firstErrorAt
      lastErrorAt
      errorType
      errorMessage
      jiraTicketKey
      schedulerArn
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const updateRetryState = /* GraphQL */ `
  mutation UpdateRetryState(
    $input: UpdateRetryStateInput!
    $condition: ModelRetryStateConditionInput
  ) {
    updateRetryState(input: $input, condition: $condition) {
      id
      customerId
      documentId
      queueArn
      retryCount
      firstErrorAt
      lastErrorAt
      errorType
      errorMessage
      jiraTicketKey
      schedulerArn
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const deleteRetryState = /* GraphQL */ `
  mutation DeleteRetryState(
    $input: DeleteRetryStateInput!
    $condition: ModelRetryStateConditionInput
  ) {
    deleteRetryState(input: $input, condition: $condition) {
      id
      customerId
      documentId
      queueArn
      retryCount
      firstErrorAt
      lastErrorAt
      errorType
      errorMessage
      jiraTicketKey
      schedulerArn
      ttl
      createdAt
      updatedAt
    }
  }
`;
